module.exports = __webpack_public_path__ + "static/media/dragLoading.35e29f35.gif";